import React from 'react'
import Dialog, { Spinner } from './Dialog'
import s from './GuestListModal.module.scss'

const GuestListModal = ({ title, state, onClose }) => {
  const { loading, error, items } = state || {}

  const subtitle = items ? `Всего записей: ${items.length}` : null

  return (
    <Dialog isOpen={!!title} onClose={onClose} title={title} subtitle={subtitle}>
      {loading && (
        <div className={s.message}>
          <Spinner />
          Загрузка списка…
        </div>
      )}

      {!loading && error && <div className={s.message}>Не удалось загрузить список</div>}

      {!loading && !error && items && !items.length && <div className={s.message}>Записей нет</div>}

      {!loading && !error && !!items?.length && (
        <ol className={s.list}>
          {items.map(item => (
            <li key={item.id}>
              <span>
                {item.name}
                {item.parent ? (
                  <span className={s.parent}>Вышестоящее подразделение: {item.parent}</span>
                ) : null}
              </span>
            </li>
          ))}
        </ol>
      )}
    </Dialog>
  )
}

export default GuestListModal
